import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrencySelect } from '../ui/select-controls/currency-select.model';
import { UrlHelperService } from '@core/services/url-helper.service';

/**
 *
 * Handle currency conversions for our Money Control
 * 
 */

@Injectable({
  providedIn: 'root'
})
export class CurrencyConverterService {

  constructor(private http: HttpClient, private urlHelper: UrlHelperService) { }

  convert(select: CurrencySelect, amount: number): any {
    var url = this.buildUrl(select, amount);
    return this.http.get(url);
  }

  private buildUrl(select: CurrencySelect, amount: number): string {
    var url = this.urlHelper.getApiUrl();
    url += select.apiController;
    url += "/ConvertCurrency";

    var currentCurrency: string = "";
    if (select.previousValue) {
      var o = select.previousValue as object;
      currentCurrency = o[select.valueMember as keyof typeof o];
    }

    var foreignCurency = select.singleValue[select.valueMember];

    url += "?amount=" + amount + "&currentCurrency=" + currentCurrency + "&foreignCurrency=" + foreignCurency + "&timestamp=" + select.timestamp;

    return url;
  }

}
